module.exports = __webpack_public_path__ + "static/media/bg1.2f974fc1.png";